<template><div class="view">

	<main>

		<div class="criterias">

			<div class="criteria-cols">

				<div class="criteria" v-if="false">
					<label>Name 1</label>
					<div class="input">
						<input type="text" v-model="criteria.name" @keyup.enter="doAutoSearch()" @change="doAutoSearch()" placeholder="All">
					</div>
				</div>

				<div class="criteria">
					<label>Name</label>
					<vue-autosuggest
						v-if="nameselect_suggestions"
						:suggestions="nameselect_suggestions"
						:input-props="{id:'autosuggest__input'}"						
						@input="nameselect_onInput"
						@selected="nameselect_onSelected"
					>  					
					</vue-autosuggest>
				</div>

				<div class="criteria" v-if="false">
					<label>Name (list)</label>
					<div class="input">
						<select v-model="criteria.name" @change="doAutoSearch()">
							<option :value="undefined">Select...</option>
							<option v-for="(option,option_i) in model_names" v-bind:value="option.full_name" :key="'dadssd'+option_i">
								{{option.full_name}}
							</option>
						</select>
						<div class="cri-select-arrow"></div>
					</div>
				</div>

				<div class="criteria">
					<label>Gender</label>
					<div class="input">
						<select v-model="criteria.gender" @change="doAutoSearch()">
							<option value="any">All</option>
							<option value="female">Female</option>
							<option value="male">Male</option>
						</select>
						<div class="cri-select-arrow"></div>
					</div>
				</div>

				<div class="criteria">
					<label>Height</label>
					<div class="input">
						<div class="a">
							<input type="text" min="120" max="210" step="1" v-model="criteria.height_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{heightdef}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="text" min="120" max="210" step="1" v-model="criteria.height_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{heightdef}}</div>
						</div>
					</div>
				</div>

				<div class="criteria">
					<label>Size</label>
					<div class="input">
						<div class="a">
							<input type="number" min="120" max="210" step="1" v-model="criteria.size_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{metrics}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" min="120" max="210" step="1" v-model="criteria.size_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{metrics}}</div>
						</div>
					</div>
				</div>

				<div class="criteria lo-hi">
					<label>Chest</label>
					<div class="input">
						<div class="a">
							<input type="number" v-model="criteria.chest_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" v-model="criteria.chest_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
					</div>
				</div>

				<div class="criteria lo-hi">
					<label>Waist</label>
					<div class="input">
						<div class="a">
							<input type="number" v-model="criteria.waist_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" v-model="criteria.waist_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
					</div>
				</div>

				<div class="criteria lo-hi" v-if="false">
					<label>Collar</label>
					<div class="input">
						<div class="a">
							<input type="number" v-model="criteria.collar_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" v-model="criteria.collar_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
					</div>
				</div>

				<div class="criteria lo-hi">
					<label>Hips</label>
					<div class="input">
						<div class="a">
							<input type="number" v-model="criteria.hips_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" v-model="criteria.hips_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{cmin}}</div>
						</div>
					</div>
				</div>

				<div class="criteria lo-hi">
					<label>Shoes</label>
					<div class="input">
						<div class="a">
							<input type="number" v-model="criteria.shoes_from" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{metrics}}</div>
						</div>
						<div class="b">To</div>
						<div class="c">
							<input type="number" v-model="criteria.shoes_to" @keyup.enter="doAutoSearch()" @change="doAutoSearch()">
							<div class="valsuf">{{metrics}}</div>
						</div>
					</div>
				</div>

				<div class="criteria">
					<label>Hair color</label>
					<tags-input element-id="tags"
						v-model="tagValue.hair_color"
						:existing-tags="tagOptions(hair_colors)"
						typeahead-style="dropdown"
						:typeahead-activation-threshold="0"
						:typeahead="true"
						:only-existing-tags="true"
						:placeholder="''"
					/>
				</div>

				<div class="criteria">
					<label>Eye color</label>
					<tags-input element-id="tags"
						v-model="tagValue.eye_color"
						:existing-tags="tagOptions(eye_colors)"
						typeahead-style="dropdown"
						:typeahead-activation-threshold="0"
						:typeahead="true"
						:only-existing-tags="true"
						:placeholder="''"
					/>
				</div>

				<div class="criteria" v-if="loggedin_user">
					<label>Piercing</label>
					<div class="input">
						<select v-model="criteria.has_piercing" @change="doAutoSearch()">
							<option value="any">All</option>
							<option value="1">Yes</option>
							<option value="0">No</option>
						</select>
						<div class="cri-select-arrow"></div>
					</div>
				</div>

				<div class="metrics-toggler">
					<span :class="{'active':(metrics=='eu')}" @click="setMetrics('eu')">EU</span>
					/
					<span :class="{'active':(metrics=='us')}" @click="setMetrics('us')">US</span>
				</div>

			</div>

			<div class="btn btn-black" :class="{'is-searching':searching}" @click="doSearch()">
				{{ (searching) ? '· · ·' : 'Search' }}
			</div>

		</div>

		<div class="none-found" v-if="show_none_found">No models found...</div>

		<div class="results" v-if="results && results.length">
			<router-link :to="'/model/'+result.slug" class="result" v-for="( result, result_i ) in results" :key="'d132d'+result_i">
				<span class="img" :style="resultbgimg(result)"></span>				
				<span class="name">
					<span class="fn">
						{{result.first_name}}
					</span>
					<span class="ln">
						{{result.last_name}}
					</span>
				</span>
			</router-link>
		</div>	

	</main>


</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import store from '.././store/store.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: {
		
	},

	data(){ return {

		tagValue: {
			hair_color: [],
			eye_color: [],
		},
		
		searching: false,
		show_none_found: false,

		criteria: {
			
			name: undefined,
			
			height_from: undefined,
			height_to: undefined,
			
			size_from: undefined,
			size_to: undefined,
			
			waist_from: undefined,
			waist_to: undefined,
			
			hips_from: undefined,
			hips_to: undefined,
			
			chest_from: undefined,
			chest_to: undefined,

			shoes_from: undefined,
			shoes_to: undefined,

			collar_from: undefined,
			collar_to: undefined,

			hair_color: undefined,
			eye_color: undefined,
			gender: 'any',
			has_piercing: 'any',

		},

		results: undefined,

	}},

	computed: {

		cmin(){ return ( this.metrics === 'eu' ? 'cm' : 'in' ) },
		heightdef(){ return ( this.metrics === 'eu' ? 'cm' : 'ft/in' ) },

		eye_colors(){ return this.$store.state.model_eye_color_options },
		hair_colors(){ return this.$store.state.model_hair_color_options },
		model_names(){ return this.$store.state.model_names },

		nameselect_suggestions(){

			if( !this.criteria.name ) return [{data:a}]
			if( !this.model_names ) return [{data:a}]

			var a = []
			for( let i = 0; i < this.model_names.length; i++ ) {
				let v = this.model_names[i].full_name
				if( v.toLowerCase().indexOf(this.criteria.name.toLowerCase()) === -1 ) continue
				a.push(v)
			}
			if( a.length > 7 ) a = a.slice(0,7)
			return [{data:a}]
		},

	},

	methods: {

		replace(a,b,str){ return str.replace(a,b) },

		doAutoSearch(){
			//this.doSearch()
		},

		onChange_hair_color(e){
			
			var values = []
			for( let o of e.target.options ) if( o.selected ) values.push(o.value)
			//values = values.join(',').toLowerCase()
			this.criteria.hair_color = values
			this.doAutoSearch()
		},

		doSearch(){

			let input = JSON.parse(JSON.stringify(this.criteria))

			input.metrics = this.metrics

			if( input.gender === 'any' ) 		input.gender = undefined
						
			input.hair_color = this.parseTagValue('hair_color')
			input.eye_color = this.parseTagValue('eye_color')
			if( !input.hair_color || input.hair_color == '' ) delete input.hair_color
			if( !input.eye_color || input.eye_color == '' ) delete input.eye_color
			
			if( input.has_piercing === 'any' ) 	input.has_piercing = undefined

			if( !this.loggedin_user ) delete input.has_piercing

			delete input.collar

			
			let _this = this

			//_this.results = undefined

			_this.searching = true
			_this.show_none_found = false

			this.fetch( 'models_search', input, 
			{ onSuccess: function(output){
			
				_this.searching = false

				if( !output || !output.data || !output.data.models || !output.data.models.length ) {
					_this.show_none_found = true
					//_this.msg('No models found...')
					return
				}

				let results = output.data.models

				_this.results = results

				setTimeout(function(){
					_this.focusOnResults()
				}, 0)

			}, onError: function(output){
			
				_this.searching = false
				_this.show_none_found = true
				//_this.msg('No models found...')

			}})

		},

		focusOnResults(){

			var el = document.querySelector('.results')
			if( !el ) return
			var top = el.offsetTop
			var wh = window.innerHeight
			var scrollY = window.scrollY
			//console.log(top)
			//console.log(wh)
			//console.log(top)
			//console.log(scrollY)

			//if( top > scrollY ) 
			helpers.scrollTo2(top, 600)			
			
		},

		resultbgimg(result){
			let css = {}
			if( result.img_url ) css['background-image'] = 'url('+result.img_url+')'
			return css
		},

		
		nameselect_onInput(text){
			this.criteria.name = text
		},

		nameselect_onSelected(item){
			if(!item) {
				var v = this.nameselect_suggestions[0].data[0]
				return this.criteria.name = v
			}
			this.criteria.name = item.item

			// if a model is chosen, and not just s astring -> go directly to model

			for( let model of this.model_names ) {
				if( model.full_name.toLowerCase() === this.criteria.name.toLowerCase() ) {
					console.log('model exact match')
					this.goto('/model/'+model.slug)
					break;
				}
			}

		},

		tagOptions(list){
			var o = []
			if( !list ) return o
			for( let h of list ) {
				h = h.replace('/',' ',h)
				o.push({ key:h, value:h })
			}
			return o
		},

		parseTagValue(key){			
			var values = this.tagValue[key]
			if( !values ) return key
			var o = []
			for( let v of values ) o.push( v.value.toLowerCase() )
			if( o ) o = o.join(',')
			return o
		},

	},

	created(){

		this.$store.dispatch('fetch_model_names')
		this.$store.dispatch('fetch_model_eye_hair_color_options')

	},
	
	mounted(){
		
		
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/ModelSearch.vue